// Imports

import React, { FunctionComponent } from 'react';

import { IconHandlerType } from '../types';
import { IconType } from 'react-icons/lib';
import { TypeHelper } from '../helpers';

// Type

// Component

const IconHandler: FunctionComponent<IconHandlerType> = ({ Icon, text, size = '1.25em', className = '' }): JSX.Element => {
  return React.cloneElement(
    React.isValidElement(Icon) ? (
      Icon
    ) : TypeHelper.isInstanceOf<IconType>(Icon) ? (
      <Icon size={size} className={`flex-shrink-0 ${className}`} />
    ) : (
      <></>
    ),
    text ? { alt: text, title: text } : {},
  );
};

// Export

export default IconHandler;
